module.exports = __webpack_public_path__ + "media/images/icons/energie-icons-geraete-beleuchtung-bfdeebb7d12685a2a9060db9f7d18f30.svg";